import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import CampaignList from './CampaignList';
import CampaignCreate from './CampaignCreate';
import CustomerSegments from './CustomerSegments';
import SegmentBuilder from './SegmentBuilder';

const MarketingRouter = () => {
  const location = useLocation();

  // Extract the path after /marketing
  const path = location.pathname.replace('/marketing', '') || '/';

  if (path.startsWith('/segments/create')) {
    return <SegmentBuilder />;
  }

  if (path.startsWith('/segments')) {
    return <CustomerSegments />;
  }

  if (path.startsWith('/create')) {
    return <CampaignCreate />;
  }

  // Default to campaign list
  return <CampaignList />;
};

export default MarketingRouter;